import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Services.css';

const Services = () => {
  const [activeCategory, setActiveCategory] = useState('mens');

  const servicesData = {
    mens: {
      id: 'mens',
      category: "Men's Grooming",
      details: [
        { subcategory: 'Haircut & Shave', items: ['Basic Haircut', 'Advance Haircut', 'Shave', 'Beard Trim'] },
        { subcategory: 'Color', items: ['Highlight per Streak', 'Beard & Moustache (Ammonia)', 'Beard & Moustache (Ammonia-Free)'] },
        { subcategory: 'Hair Treatments', items: ['Deep Conditioning', 'Hair Spa', 'Dandruff Treatment', 'Anti-Hair Loss Treatment'] },
        { subcategory: 'Hair Texture', items: ['Straightening', 'Smoothening', 'Keratin', 'Botox Treatment', 'Nanoplastia'] },
        { subcategory: 'Styling', items: ['Hair Wash & Conditioning', 'Hair Styling', 'Ironing', 'Tongs'] },
        { subcategory: 'Head Massages', items: ['Coconut Oil', 'Mint (Cooling)', 'Aloe Vera Oil', 'Almond Oil', 'Olive Oil', 'Aroma'] },
      ],
    },
    womens: {
      id: 'womens',
      category: "Women's Beauty",
      details: [
        { subcategory: 'Hair Cuts', items: ['Long Layer Hair Cut', 'Feather Cut', 'Diamond Cut', 'Basic Hair Cut', 'Front Frame Cut', 'Advance Hair Cut', 'Step Hair Cut', 'Butterfly Cut'] },
        { subcategory: 'Hair Styling', items: ['Hair Wash & Conditioner', 'Straight Blow Dry', 'Blow Dry Setting', 'Temporary Ironing', 'Temporary Curlers'] },
        { subcategory: 'Hair Treatments', items: ['Smoothening Hair Spa', 'Color Protect Hair Spa', 'Repairing Hair Spa', 'Collagen Treatment', 'Anti-Dandruff Treatment', 'Hair Fall Treatment'] },
        { subcategory: 'Hair Color & Texture', items: ['Root Touch Up (Ammonia-Free)', 'Global Color', 'Fashion Color Per Foil', 'Full Highlights', 'French Balayage', 'Hair Straightening', 'Hair Smoothening', 'Keratin Treatment', 'Hair Botox'] },
        { subcategory: 'Threading', items: ['Eyebrows', 'Upper Lip', 'Forehead', 'Chin', 'Side Locks', 'Full Face'] },
      ],
    },
    skin: {
      id: 'skin',
      category: 'Skin & Body Care',
      details: [
        { subcategory: 'Clean Ups & Facials', items: ['Fruit Clean Up', 'De-Tan Clean Up', 'Herbal Clean Up', 'Gold Facial', 'Diamond Facial', 'Anti-Aging Facial', 'Whitening & Brightening Facial', 'Vitamin C Facial'] },
        { subcategory: 'Premium Facials', items: ['Gloss It For Hydration & Glow', 'Energize For Anti-Pollution', 'Define For Firming', 'Pomegranate For Radiance', 'Ultra Bright For Ultimate Glow'] },
        { subcategory: 'De-Tan & Waxing', items: ['Face & Neck De-Tan', 'Full Arms De-Tan', 'Full Legs De-Tan', 'Full Body De-Tan', 'Full Face Waxing', 'Full Arms Waxing', 'Full Legs Waxing', 'Full Body Waxing'] },
        { subcategory: 'Manicure & Pedicure', items: ['Regular Manicure', 'Regular Pedicure', 'Spa Manicure', 'Spa Pedicure', 'Crystal Manicure', 'Crystal Pedicure', 'Aroma Manicure/Pedicure', 'Dead Sea Mineral Spa'] },
      ],
    },
    bridal: {
        id: 'bridal',
        category: 'Bridal & Specialty',
        details: [
            { subcategory: 'Makeup', items: ['Eye Makeup', 'Party Makeup', 'Glossy Makeup', 'Bridal Makeup'] },
            { subcategory: 'Hair Styles', items: ['Party Hair Style', 'Messy Hair Style', 'Bridal Hair Style'] },
            { subcategory: 'Finishing Touches', items: ['Saree Draping', 'Bridal Saree Draping', 'Arabic Mehandi (Per Side)', 'Bridal Mehandi'] },
            { subcategory: 'Extensions', items: ['Gel Nail Extension', 'Acrylic Nail Extension', 'Classic Volume Eyelash', 'Hybrid Volume Eyelash', 'Russian Volume Eyelash', 'Nano Ring Hair Extension'] },
        ]
    },
    cosmetology: {
      id: 'cosmetology',
      category: 'Advanced Cosmetology',
      details: [
        { subcategory: 'Skin Rejuvenation', items: ['Chemical Peels', 'Microneedling', 'Laser Skin Rejuvenation', 'Hyder Facial Treatment', 'BB Glow Treatment'] },
        { subcategory: 'Permanent Makeup', items: ['Permanent Eyebrows', 'Permanent Mole', 'Permanent Lip Coloring', 'Permanent Lip Neutralizing'] },
        { subcategory: 'Specialized Treatments', items: ['Hair PRP', 'Laser Hair Removal', 'Mole Removal', 'Warts and Skin Tags Removal', 'Under Eye & Dark Circle Treatment'] },
      ],
    },
  };

  const selectedCategoryData = servicesData[activeCategory];

  return (
    <section id="services" className="services-section-unique">
      <div className="services-container-unique">
        <motion.div
          className="services-header-unique"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <h2 className="services-title-unique">A Symphony of Services</h2>
          <p className="services-subtitle-unique">
            Curated treatments designed for timeless elegance and modern sophistication.
          </p>
        </motion.div>

        <div className="services-layout-unique">
          {/* Left Column: Category Selector */}
          <div className="service-category-selector">
            <ul>
              {Object.values(servicesData).map((cat) => (
                <li key={cat.id}>
                  <button
                    className={`category-btn-unique ${activeCategory === cat.id ? 'active' : ''}`}
                    onClick={() => setActiveCategory(cat.id)}
                  >
                    {cat.category}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column: Service Details */}
          <div className="service-details-display">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeCategory}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5, ease: 'easeInOut' }}
              >
                <h3 className="displayed-category-title">{selectedCategoryData.category}</h3>
                <div className="details-grid-unique">
                  {selectedCategoryData.details.map((sub, index) => (
                    <div key={index} className="subcategory-card-unique">
                      <h4 className="subcategory-title-unique">{sub.subcategory}</h4>
                      <ul className="service-list-unique">
                        {sub.items.map((item, itemIndex) => (
                          <li key={itemIndex}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
